import React, { useMemo } from "react";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";
import styled, { withTheme } from "styled-components";
import ProfileCard from "../../../components/ui-library/ProfileCard/ProfileCard";
import SmartPageHeader from "../../../components/smart/PageHeader/PageHeader";
import SmartCommentTable from "../../../components/smart/CommentTable/CommentTable";

const ProfileCardsWrapper = styled.div``;

const DataComments = (props) => {
  const { route, studies, canViewComments } = props;

  const studyCode = useMemo(
    () =>
      studies?.find(
        (o) => o?.studyId?.toLowerCase() === route?.study?.toLowerCase()
      )?.code ?? "",
    [studies, route]
  );

  return (
    <>
      <SmartPageHeader studyId={route.study} title={studyCode} />
      <ProfileCardsWrapper>
        {canViewComments && (
          <div className="mt-4">
            <ProfileCard title="Data Comments" showIcon={false}>
              <SmartCommentTable />
            </ProfileCard>
          </div>
        )}
      </ProfileCardsWrapper>
    </>
  );
};

export default connect(mapStateToPropsLogin, null)(withTheme(DataComments));
